/**
 * Filters Hover-to-Open
 * Opens filter dropdowns on hover for desktop users
 */

(function() {
  const HOVER_DELAY = 100; // ms before opening
  const CLOSE_DELAY = 200; // ms before closing

  function initFilterHover() {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (!isDesktop) return;

    const filterPanels = document.querySelectorAll('.facets--horizontal .facets__panel');
    
    filterPanels.forEach(panel => {
      let openTimeout = null;
      let closeTimeout = null;

      const openPanel = () => {
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          panel.setAttribute('open', '');
        }, HOVER_DELAY);
      };

      const closePanel = () => {
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(() => {
          // Only close if not hovering over panel or its content
          if (!panel.matches(':hover') && !panel.querySelector('.facets__inputs:hover')) {
            panel.removeAttribute('open');
          }
        }, CLOSE_DELAY);
      };

      // Mouse events for the summary (trigger)
      const summary = panel.querySelector('.facets__summary');
      if (summary) {
        summary.addEventListener('mouseenter', openPanel);
        summary.addEventListener('mouseleave', closePanel);
      }

      // Keep open when hovering over content
      const content = panel.querySelector('.facets__inputs');
      if (content) {
        content.addEventListener('mouseenter', () => {
          clearTimeout(closeTimeout);
        });
        content.addEventListener('mouseleave', closePanel);
      }

      // Also handle the panel itself
      panel.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
      });
      panel.addEventListener('mouseleave', closePanel);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterHover);
  } else {
    initFilterHover();
  }

  // Reinitialize on resize (in case user resizes to desktop)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initFilterHover, 250);
  });

  // Reinitialize after Shopify section renders (for theme editor)
  document.addEventListener('shopify:section:load', initFilterHover);
})();
